import { Component, OnInit, OnDestroy } from "@angular/core";
import { Params, Router, ActivatedRoute } from "@angular/router";
import { AppVersionsService } from "../services/app-versions.service";
import { BaseEditComponent } from "../../core/common/base-component";
import { FormUtil } from "../../core/form.util";
import { Title } from '@angular/platform-browser';

@Component({
  selector: "ch-app-versions-edit",
  templateUrl: "./app-versions-edit.component.html",
  styleUrls: ["./app-versions-edit.component.css"]
})
export class AppVersionsEditComponent extends BaseEditComponent
  implements OnInit, OnDestroy {
  private system: string;
  public locationData: any = {};
  public isCountryCh: boolean;
  private parentId: string;

  public errors: any = {};
  public chosenAppVersions = false;

  public breadcrumb: any[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private locationService: AppVersionsService,
    private titleService: Title,
  ) {
    super();
  }

  ngOnInit() {
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        this.system = params.system;
        this.parentId = params.parentId;
        this.fetchData(this.system);
      });
  }

  ngOnDestroy() {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private fetchData(system: string) {
    this.loading = true;
    this.locationService.getAppVersion(system).subscribe(
      data => {
        this.locationData = data.json();
        this.titleService.setTitle(`${this.system} | App Versions | CODE Hospitality CMS`);
      },
      () => {},
      () => {
        this.loading = false;
        this.loaded = true;
      }
    );
  }

  public edit(form) {
    if (!FormUtil.isValid(form)) {
      return;
    }
    const reqData: any = { ...this.locationData };
    if (
      reqData.minimalStoreVersion > reqData.currentStoreVersion ||
      reqData.minimalVersion > reqData.currentVersion
    ) {
      return;
    }
    this.loading = true;

    this.locationService.updateAppVersion(reqData, this.system).subscribe(
      _ => {
        this.loading = false;
        this.cancel();
      },
      err => {
        this.loading = false;
        if (!(err.errors instanceof Array)) {
          return;
        }
        err.errors.forEach(item => {
          this.errors[item.field] = item.message;
        });
      }
    );
  }

  public cancel() {
    const targetAppVersionsId = this.editMode
      ? this.locationData.parentAppVersionsId
      : this.parentId;
    const url =
      "/admin/app-versions" +
      (targetAppVersionsId ? "?parentId=" + targetAppVersionsId : "");
    this.router.navigateByUrl(url);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/app-versions/app-versions-edit/app-versions-edit.component.ts